var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "RouterLink",
    {
      attrs: {
        to: {
          name: _vm.routes.CONTRACTOR_DETAILS_ABOUT,
          params: { id: _vm.contractorId },
        },
      },
    },
    [
      _c(
        "div",
        {
          staticClass:
            "box-content flex items-center chipHeight border border-gray-400 hover:border-primary-500 rounded-full text-gray-800 bg-white tag-margin mb-1 mr-1 cursor-pointer",
        },
        [
          _c(
            "div",
            {
              staticClass:
                "chipHeight chipCircleWidth bg-primary-500 rounded-full flex items-center justify-center text-white",
            },
            [_vm._v(_vm._s(_vm.contractorName[0]))]
          ),
          _c(
            "div",
            { staticClass: "flex text-xs cursor-pointer px-2 truncate" },
            [
              _vm._t("default", function () {
                return [
                  _c("span", { staticClass: "truncate" }, [
                    _vm._v(_vm._s(_vm.contractorName)),
                  ]),
                ]
              }),
            ],
            2
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }